import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'

import EventEmitter from './EventEmitter.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'

/**
 * Class to manage resource loading for 3D models, textures, and other assets.
 * Extends EventEmitter for emitting events during the loading process.
 * @extends {EventEmitter}
 * @category Experience
 * @subcategory Utils
 */
export default class Resources extends EventEmitter
{
    /**
     * Creates an instance of Resources.
     * @param {Array} sources - Array of source objects to be loaded, each with a `type` and `path`.
     */
    constructor(sources)
    {
        super()

        this.sources = sources

        /**
         * THREE.LoadingManager instance to manage loading events and progress.
         * @type {THREE.LoadingManager}
         */
        this.loadingManager = new THREE.LoadingManager(
            // Loaded callback
            () => {
                gsap.to(overlayMaterial.uniforms.uAlpha, { duration: 1, value: 0 })
              // Hide the loading screen
            // document.getElementById('spinner').style.display = 'none';
            // document.getElementById('fullscreen-overlay').style.display = 'none';
        
        
            }
            ,
        
            (url, itemsLoaded, itemsTotal) => {
              // Update the progress bar
              const progressRatio = itemsLoaded / itemsTotal
            }
          );
          this.loadingManager.onStart = function(url, itemsLoaded, itemsTotal) {
            // document.getElementById('spinner').style.display = 'block';
            // document.getElementById('fullscreen-overlay').style.display = 'block';
          };
        
          // Hide spinner once everything has finished loading
          this.loadingManager.onLoad = function() {
            // document.getElementById('spinner').style.display = 'none';
            // document.getElementById('fullscreen-overlay').style.display = 'none';
          };
        this.items = {}
        this.toLoad = this.sources.length
        this.loaded = 0
var data
        this.setLoaders()
        this.loading()
        // this.startLoading()
      
    }
    
    cleanup() {
        // Remove event listeners
        this.loadingManager.onStart = null;
        this.loadingManager.onLoad = null;
    
        // Dispose of loaded textures, models, and other resources
        for (const key in this.items) {
            const item = this.items[key];
    
            // Dispose of textures
            if (item instanceof THREE.Texture) {
                item.dispose();
            }
    
            // Dispose of materials
            if (item.material) {
                if (Array.isArray(item.material)) {
                    item.material.forEach((mat) => mat.dispose());
                } else {
                    item.material.dispose();
                }
            }
    
            // Dispose of geometry
            if (item.geometry) {
                item.geometry.dispose();
            }
        }
    
        // Clear loaded items map
        this.items = {};
    
        // Set loaders and sources to null
        this.loaders = null;
        this.sources = null;
        this.toLoad = 0;
        this.loaded = 0;
    
        // Remove reference to loadingManager
        this.loadingManager = null;
    }

    /**
     * Initializes loaders for different resource types (GLTF, OBJ, textures, etc.).
     */
  setLoaders()
    {
        this.loaders = {}
        this.loaders.gltfLoader = new GLTFLoader(this.loadingManager)
        this.loaders.glbLoader = new GLTFLoader(this.loadingManager)
        this.loaders.objLoader=new OBJLoader(this.loadingManager)
        this.loaders.textureLoader = new THREE.TextureLoader(this.loadingManager)
        this.loaders.cubeTextureLoader = new THREE.CubeTextureLoader(this.loadingManager)
        this.loaders.dracoLoader=new DRACOLoader()
        this.loaders.dracoLoader.setDecoderPath('/draco/')
        this.loaders.glbLoader.setDRACOLoader(this.loaders.dracoLoader)

    }

    /**
     * Starts loading resources from the provided sources.
     * @param {string} pathFile - Optional file path for certain resource types.
     */
  startLoading(pathFile)
    {
        // Load each source
        for(const source of this.sources)
        {
            if(source.type === 'gltfModel')
            {
                this.loaders.gltfLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            else if(source.type === 'glbModel')
            {
                // console.log("nothing to load");
                this.loaders.glbLoader.load(
                    pathFile,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            else if(source.type === 'OBJModel')
            {
                this.loaders.objloader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            else if(source.type === 'texture')
            {
                this.loaders.textureLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            else if(source.type === 'cubeTexture')
            {
                this.loaders.cubeTextureLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            else if(source.type === 'json'){
var data
                source.path = data
                this.loaders.gltfLoader.parse(
                    JSON.stringify(source.path),"",
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
        }
    }

    /**
     * Handles the loading of a single resource and emits an event when all resources are loaded.
     * @param {Object} source - The resource object being loaded.
     * @param {Object} file - The loaded resource file.
     */
    sourceLoaded(source, file)
    {
        this.items[source.name] = file

        this.loaded++

        if(this.loaded === this.toLoad)
        {
            this.trigger('ready')
        }
    }
    /**
     * Placeholder for any additional logic during the loading process.
     */
    loading(){
       
        
    }
}